<template>
  <div class="search_bar">
    <div class="search_top">
      <div class="search_auditLogging">
        <div class="search_area">
          <div class="auditLogging_title_label">
            <div class="data_time_label">
              <div>
                {{ startDateTimeLabel }}
              </div>
            </div>
            <div class="date_time">
              <datepicker
                placeholder="Select Date"
                :value="value"
                :config="start_config"
                :locale="ja"
                id="start"
                @on-change="setStartDateTime"
                class="start_datepicker start_date_time"
              >
              </datepicker>
            </div>
            <div class="div_clear_button">
              <input
                type="button"
                :value="clearButton"
                class="clear_button"
                @click="clearStartAction"
              />
            </div>
            <div class="data_time_label">
              {{ endDateTimeLabel }}
            </div>
            <div class="date_time">
              <datepicker
                placeholder="Select Date"
                :value="value"
                :config="end_config"
                :locale="ja"
                id="end"
                @on-change="setEndDateTime"
                class="end_datepicker end_date_time"
              >
              </datepicker>
            </div>
            <div class="div_clear_button">
              <input
                type="button"
                :value="clearButton"
                class="clear_button"
                @click="clearEndAction"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="falseWord" @close="closeModal"> </completeModalWindow>
    </div>
    <div class="false_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="falseWord" @close="close"> </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  data() {
    return {
      searchButton: '検索',
      clearButton: '×',
      startDateTimeLabel: '発生日時（開始）：',
      endDateTimeLabel: '発生日時（終了）：',
      falseWord: '',
      showCompleteModal: false,
      showloadingModal: false,
      value: '',
      ja: japanese,
      start_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date().setDate(new Date().getDate() - 7),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      end_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date(),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      findAuditLoggings: [],
      // 検索ボタン連打防止フラグ
      searchActionFlag: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
    completeModalWindow,
    loadingModalWindow,
    datepicker
  },
  methods: {
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes
    },
    close(e) {
      this.showCompleteModal = false
    },
    closeModal(e) {
      this.showCompleteModal = false
    },
    setStartDateTime(e) {
      let startDate = new Date(e)
      startDate.setSeconds(0)
      this.$store.dispatch('auditLoggings/searchStartDateTime', startDate)
      this.customFormatter(e)
    },
    setEndDateTime(e) {
      let endDate = new Date(e)
      endDate.setSeconds(59)
      this.$store.dispatch('auditLoggings/searchEndDateTime', endDate)
      this.customFormatter(e)
    },
    async searchAction(e) {
      if (!this.searchActionFlag) {
        this.searchActionFlag = true
        this.showloadingModal = true
        // 発生日時取得
        let start = document.getElementById('start').value
        let end = document.getElementById('end').value
        let startDateTime = 0
        let endDateTime = 0
        if (start === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_320001
          let eventType = 9
          let reason = 'MSGCRC0202'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0202.name +
            this.errorMsg.MSGCRC0202.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
          this.showloadingModal = false
          this.searchActionFlag = false
          return
        }
        if (end === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_320001
          let eventType = 9
          let reason = 'MSGCRC0203'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0203.name +
            this.errorMsg.MSGCRC0203.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
          this.showloadingModal = false
          this.searchActionFlag = false
          return
        }
        let startDate = new Date(start)
        startDate.setSeconds(0)
        // UnixTimeに変換
        startDateTime = startDate.getTime()

        let endDate = new Date(end)
        endDate.setSeconds(59)
        // UnixTimeに変換
        endDateTime = endDate.getTime()

        if (startDateTime > endDateTime) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_320001
          let eventType = 9
          let reason = 'MSGCRC0200'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0200.name +
            this.errorMsg.MSGCRC0200.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showCompleteModal = true
          this.showloadingModal = false
          this.searchActionFlag = false
          return
        }
        // 検索対象取得
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        try {
          await this.$store.dispatch('auditLoggings/setAuditLoggings', {
            startDateTime,
            endDateTime
          })
          this.findAuditLoggings = this.$store.getters['auditLoggings/getAuditLoggingByDate'](
            this.$store.state.auditLoggings.searchvalue
          )
          this.$store.dispatch('auditLoggings/changeFindAuditLoggings', this.findAuditLoggings)
          let message = this.$store.state.auditLoggings.message.split(',')
          if (message[0] === 'MSGCRC0199') {
            this.falseWord =
              this.errorMsg.MSGCRC0199.name +
              this.errorMsg.MSGCRC0199.beforeValue +
              (Number(message[1]) + 1) +
              this.errorMsg.MSGCRC0199.middleValue +
              message[1] +
              this.errorMsg.MSGCRC0199.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showCompleteModal = true
          }
        } catch (error) {
          let eventType = 3
          let reason = ''
          if (
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.message
          ) {
            let errorMessage = error.response.data.header.message.split(',')
            if (errorMessage[0] === 'MSGCRC0200') {
              this.falseWord =
                this.errorMsg.MSGCRC0200.name +
                this.errorMsg.MSGCRC0200.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0202') {
              this.falseWord =
                this.errorMsg.MSGCRC0202.name +
                this.errorMsg.MSGCRC0202.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0203') {
              this.falseWord =
                this.errorMsg.MSGCRC0203.name +
                this.errorMsg.MSGCRC0203.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.falseWord =
                this.errorMsg.MSGCRC0075.name +
                this.errorMsg.MSGCRC0075.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              errorMessage[0] = 'MSGCRC0075'
            }
            reason = errorMessage[0] + ' '
            reason += error.response.status
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.falseWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showCompleteModal = true
        }
        this.showloadingModal = false
        this.searchActionFlag = false
      }
    },
    clearStartAction(e) {
      document.getElementById('start').value = ''
      this.$store.dispatch('auditLoggings/searchStartDateTime', '')
    },
    clearEndAction(e) {
      document.getElementById('end').value = ''
      this.$store.dispatch('auditLoggings/searchEndDateTime', '')
    }
  }
}
</script>

<style scoped>
.search_bar {
  position: relative;
  float: left;
  width: 100%;
  color: #000;
  border-right: 1px solid #808080;
  z-index: 2;
}
.search_top {
  height: 55px;
  width: 100%;
  font-size: 0;
  text-align: right;
  background-color: #daf8f3;
  display: table;
}
.search_auditLogging {
  display: table-cell;
  vertical-align: middle;
  padding-left: 17px;
}
.data_time_label {
  float: left;
  margin: 8px 0 0 0;
}
.date_time {
  float: left;
  text-align: left;
}
.div_clear_button {
  float: left;
  padding-right: 35px;
}
.search_button {
  width: 85px;
  height: 40px;
  color: #fff;
  border-radius: 3px;
  margin: 15px 33px 0 0;
  border: none;
  background-color: #00afa8;
}
.auditLogging_title_label {
  margin: 15px 10px 0px 0;
  font-size: 14px;
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
  cursor: default;
  text-decoration: none;
  color: #39a196;
  font-weight: bold;
  float: right;
}
.search_area {
  display: table-cell;
}
.start_datepicker,
.end_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
  width: calc(100% - 30px);
}
.clear_button {
  height: 30px;
  background-color: #ffffff;
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  margin: 2px 0 0px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLoggings/auditLoggingSearch.vue